/*
    ---------------------
    --- Loader style ---
    - Table of Contents -
    ---------------------
*/

@keyframes button-loading {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.loader__init {
  display: block;
  margin: auto;

  /* Specific loader style used in ike-event-list component */
  &.animated-loading {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}

.loader__anim {
  width: 10px !important;
  height: 10px !important;
  background-color: $main-color; // main case : get shop main color
  background-color: var(--main-color);
  border-radius: 100%;
  display: inline-block;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  -webkit-animation: button-loading 1.8s infinite ease-in-out;
  animation: button-loading 1.8s infinite ease-in-out;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;

  &.grey-dark {
    background: var(--gray-dark); // used case : in a button-loader according to the shop theme (Light or Dark)
  }

  &:nth-child(1) {
    -webkit-animation-delay: -.40s;
    animation-delay: -.40s;
  }

  &:nth-child(2) {
    -webkit-animation-delay: -.20s;
    animation-delay: -.20s;
  }

  &:nth-child(3) {
    -webkit-animation-delay: .1s;
    animation-delay: .1s;
  }
}
